import { Controller } from '@hotwired/stimulus';
import appNoty from '../../libs/appNoty';

export default class extends Controller {
  static targets = ['agree'];

  static values = { message: String };

  validate(e) {
    if (this.agreeTargets.some((agree) => !agree.checked)) {
      e.preventDefault();
      const message = this.messageValue || '필수항목에 모두 동의하셔야 합니다.';
      appNoty(message, 'alert').show();
    }
  }
}
